<template>
  <div class="pb-3">
    <b-card>
      <b-row>
        <b-col cols="4">
          <b-form-group label="Nhập số MSISDN">
            <b-form-input v-model="msisdn" @keyup.enter="keyUp"/>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-row v-if="currentItem.NOTE != undefined ">
      <b-col cols="3">
        <b-form-group label="Ghi chú">
          <b-form-input v-model="currentItem.NOTE" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Loại SIM">
          <b-form-input v-model="currentItem.SIM_TYPE" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="LIFE_CYCLE_STAT_CD">
          <b-form-input v-model="currentItem.LIFE_CYCLE_STAT_CD" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Trạng thái">
          <b-form-input v-model="currentItem.TRANGTHAI" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="ACTVTN_DT">
          <b-form-input v-model="currentItem.ACTVTN_DT" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Số ngày PSC tháng 3">
          <b-form-input v-model="currentItem.SO_NGAY_PSC_T3" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Số ngày PSC tháng 4">
          <b-form-input v-model="currentItem.SO_NGAY_PSC_T4" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="TOT_RVN_AMT_T3">
          <b-form-input v-model="currentItem.TOT_RVN_AMT_T3" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="TOT_RVN_AMT_T4">
          <b-form-input v-model="currentItem.TOT_RVN_AMT_T4" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Trạng thái CCOS">
          <b-form-input v-model="currentItem.STATUS_CCOS" disabled/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-else-if="msisdn!=''">
      <b-col cols="12">
        <h3 class="text-danger">Không có thông tin!</h3>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BRow,
  BTab,
  BTabs,
  BTooltip,
  VBTooltip
} from "bootstrap-vue";
import VuePdfApp from 'vue-pdf-app'
import 'vue-pdf-app/dist/icons/main.css'
import useJwt from "@/auth/jwt/useJwt";
import Select2 from 'v-select2-component'
import {VueGoodTable} from 'vue-good-table'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import VJstree from '@/@core/components/vue-jstree'
import '@core/scss/vue/libs/vue-good-table.scss';
import XLSX from "xlsx"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import {Carousel, Slide} from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide,
    VBTooltip,
    BTooltip,
    BPagination,
    ValidationProvider,
    ValidationObserver,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormSelect,
    VueGoodTable,
    XLSX,
    BRow,
    BCol,
    BFormFile,
    BForm,
    BFormGroup,
    VuePdfApp,
    BButton,
    Select2,
    BCard,
    BCardText,
    flatPickr,
    BTab,
    BCardText,
    BTabs,
    FeatherIcon,
    VJstree
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data() {
    return {
      currentItem: {},
      msisdn: "",
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 100
      },
      required
    };
  },
  watch: {},
  created() {

  },
  mounted() {


  },
  destroyed: function () {

  },
  methods: {
    keyUp: function () {
      this.currentItem = {};
      if (this.msisdn.startsWith("0")) {
        this.msisdn = "84" + this.msisdn.substring(1);
      } else if (!this.msisdn.startsWith("84")) {
        this.msisdn = "84" + this.msisdn;
      }
      if (this.msisdn.length == 11) {
        this.loading(true);
        this.serverParams.columnFilters = {MSISDN: this.msisdn};
        useJwt.post('getMasterDataNoLogin/WHITELIST', this.serverParams).then(response => {
          this.currentItem = response.data.result[0];
          this.loading(false);
        }).catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Lỗi lấy danh sách', icon: 'AlertTriangleIcon', variant: 'danger'}
          })
          this.loading(false);
        })
      }
    }
  }
};
</script>
<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
